module.exports = __webpack_public_path__ + "img/IMG_3450_FoamcoreMatted.ca3d30a2.jpg";